<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    created() {
        this.$store.commit('getTaiwan', 'WY')
        this.$store.dispatch('getBannerZt', '文娱')
        this.$store.dispatch('getBannerArticle2')
        this.$store.commit('getSubmit', '文娱')
        this.$store.commit('dataColor', {
            bar0: '#c423ed',
            bar1: '#237bd6',
            line0: '#ff6a04',
            line1: '#fbae08'
        })
        // this.$store.commit('getType', 2)
    },
}
</script>

<style>
/* #app .nav ul li:nth-child(3) {
    display: none;
} */
#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #c423ed;
    border-color: #c423ed;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #c423ed;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #c423ed !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #c423ed !important;
}

.content-left .title {
    border-left: 5px solid #c423ed;
}
.content-left .title h2 span {
    color: #c423ed;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #c423ed;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
    background: #c423ed;
  }
}
</style>